import { Link } from "react-router-dom";
import { ChevronRight, CheckCircle2 } from "lucide-react";

const TONES = {
  critical: "bg-danger-50 text-danger-600",
  warning: "bg-amber-50 text-amber-600",
  info: "bg-brand-50 text-brand-600",
};

const AttentionList = ({ items, loading }) => {
  if (loading) {
    return (
      <div className="space-y-2">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-12 animate-pulse rounded-xl bg-gray-50" />
        ))}
      </div>
    );
  }

  const open = items.filter((item) => item.count > 0);
  if (open.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-6 text-center">
        <span className="grid h-10 w-10 place-items-center rounded-full bg-success-50 text-success-600">
          <CheckCircle2 size={20} />
        </span>
        <p className="text-sm font-medium text-gray-800">All clear</p>
        <p className="text-xs text-gray-500">Nothing overdue or about to run out.</p>
      </div>
    );
  }

  return (
    <ul className="space-y-2">
      {open.map(({ key, icon: Icon, label, hint, count, tone, to }) => (
        <li key={key}>
          <Link
            to={to}
            className="group flex items-center gap-3 rounded-xl border border-gray-100 px-3 py-2.5 transition hover:border-gray-200 hover:bg-gray-50/70"
          >
            <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg ${TONES[tone] ?? TONES.info}`}>
              <Icon size={16} strokeWidth={2} />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium text-gray-800">{label}</span>
              {hint && <span className="block truncate text-xs text-gray-500">{hint}</span>}
            </span>
            <span className="text-lg font-semibold tabular-nums text-gray-900">{count}</span>
            <ChevronRight size={15} className="text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-gray-500" />
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default AttentionList;